Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _d3Ease=require("d3-ease");var d3Ease=_interopRequireWildcard(_d3Ease);
var _util=require("./util");
var _timer=require("../victory-util/timer");var _timer2=_interopRequireDefault(_timer);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

VictoryAnimation=function(_React$Component){_inherits(VictoryAnimation,_React$Component);




































function VictoryAnimation(props){_classCallCheck(this,VictoryAnimation);var _this=_possibleConstructorReturn(this,(VictoryAnimation.__proto__||Object.getPrototypeOf(VictoryAnimation)).call(this,
props));

_this.state={
data:Array.isArray(_this.props.data)?
_this.props.data[0]:_this.props.data,
animationInfo:{
progress:0,
animating:false}};


_this.interpolator=null;
_this.queue=Array.isArray(_this.props.data)?
_this.props.data.slice(1):[];

_this.ease=d3Ease[_this.toNewName(_this.props.easing)];




_this.functionToBeRunEachFrame=_this.functionToBeRunEachFrame.bind(_this);
_this.getTimer=_this.getTimer.bind(_this);return _this;
}_createClass(VictoryAnimation,[{key:"getTimer",value:function getTimer()

{
if(this.context.getTimer){
return this.context.getTimer();
}
if(!this.timer){
this.timer=new _timer2.default();
}
return this.timer;
}},{key:"componentDidMount",value:function componentDidMount()

{

if(this.queue.length){
this.traverseQueue();
}
}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(


nextProps){

this.getTimer().unsubscribe(this.loopID);


if(!Array.isArray(nextProps.data)){


this.queue.length=0;
this.queue.push(nextProps.data);

}else{var _queue;

(_queue=this.queue).push.apply(_queue,_toConsumableArray(nextProps.data));
}

this.traverseQueue();
}},{key:"componentWillUnmount",value:function componentWillUnmount()

{
if(this.loopID){
this.getTimer().unsubscribe(this.loopID);
}else{
this.getTimer().stop();
}
}},{key:"toNewName",value:function toNewName(

ease){

var capitalize=function capitalize(s){return s&&s[0].toUpperCase()+s.slice(1);};
return"ease"+capitalize(ease);
}},{key:"traverseQueue",value:function traverseQueue()


{var _this2=this;
if(this.queue.length){

var data=this.queue[0];

this.interpolator=(0,_util.victoryInterpolator)(this.state.data,data);

if(this.props.delay){
setTimeout(function(){
_this2.loopID=_this2.getTimer().subscribe(
_this2.functionToBeRunEachFrame,_this2.props.duration);

},this.props.delay);
}else{
this.loopID=this.getTimer().subscribe(
this.functionToBeRunEachFrame,this.props.duration);

}
}else if(this.props.onEnd){
this.props.onEnd();
}
}},{key:"functionToBeRunEachFrame",value:function functionToBeRunEachFrame(

elapsed,duration){




duration=duration!==undefined?duration:this.props.duration;
var step=duration?elapsed/duration:1;
if(step>=1){
this.setState({
data:this.interpolator(1),
animationInfo:{
progress:1,
animating:false}});


if(this.loopID){
this.getTimer().unsubscribe(this.loopID);
}
this.queue.shift();
this.traverseQueue();
return;
}





this.setState({
data:this.interpolator(this.ease(step)),
animationInfo:{
progress:step,
animating:step<1}});


}},{key:"render",value:function render()

{
return this.props.children(this.state.data,this.state.animationInfo);
}}]);return VictoryAnimation;}(_react2.default.Component);VictoryAnimation.displayName="VictoryAnimation";VictoryAnimation.propTypes={children:_react2.default.PropTypes.func,duration:_react2.default.PropTypes.number,easing:_react2.default.PropTypes.oneOf(["back","backIn","backOut","backInOut","bounce","bounceIn","bounceOut","bounceInOut","circle","circleIn","circleOut","circleInOut","linear","linearIn","linearOut","linearInOut","cubic","cubicIn","cubicOut","cubicInOut","elastic","elasticIn","elasticOut","elasticInOut","exp","expIn","expOut","expInOut","poly","polyIn","polyOut","polyInOut","quad","quadIn","quadOut","quadInOut","sin","sinIn","sinOut","sinInOut"]),delay:_react2.default.PropTypes.number,onEnd:_react2.default.PropTypes.func,data:_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.object,_react2.default.PropTypes.array])};VictoryAnimation.defaultProps={duration:1000,easing:"quadInOut",delay:0,data:{}};VictoryAnimation.contextTypes={getTimer:_react2.default.PropTypes.func};exports.default=VictoryAnimation;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-animation/victory-animation.js
// module id = 584
// module chunks = 0 1